





















import {
  defineVue3AsyncComponent,
  defineNuxtComponent,
  computed,
  ComputedRef
} from '~/utils/nuxt3-migration'
import CLink from '~/components/shared/configurable/link/CLink.vue'
import CIcon from '~/components/shared/configurable/CIcon.vue'
import { categoriesIconsMappings } from '~/constants/category/icon'
import { quickSearchCategories } from '~/constants/classified/quick-search'
import {
  QuickSearchCategory,
  QuickSearchCategories
} from '~/models/category/types'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { useNamespacedStore } from '~/compositions/store'
import { AccessToggleName } from '~/models/user/access-toggles'
import { ciDeals } from '~/icons/source/thin/deals'
import { ciRentals } from '~/icons/source/thin/rentals'

export default defineNuxtComponent({
  components: {
    CLink,
    CIcon,
    CNewBadge: defineVue3AsyncComponent(() =>
      import('~/components/shared/configurable/badge/CNewBadge.vue')
    )
  },
  props: {
    selectedCategories: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const userHasAccessTo = userGetters('userHasAccessTo')

    const categories: ComputedRef<QuickSearchCategories> = computed(() => {
      if (!userHasAccessTo(AccessToggleName.WANTED_PARTS_ACCESS)) {
        const filteredCategories = { ...quickSearchCategories }
        delete filteredCategories['wanted-parts']
        return filteredCategories
      }
      return quickSearchCategories
    })

    function getCategoryIcon(category: QuickSearchCategory) {
      if (category.name === 'deals') {
        return ciDeals
      }

      if (category.name === 'rentals') {
        return ciRentals
      }

      return categoriesIconsMappings[category.id as number]
    }

    function isActive(category: QuickSearchCategory) {
      return props.selectedCategories.includes(category.id)
    }

    return {
      categories,
      getCategoryIcon,
      isActive
    }
  }
})
